import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  ButtonsColor,
  PageBackgroundColor,
  TextColor,
  fontFamilyall,
  primaryColor,
} from "../../UtilColorPalate/UtilColorPalate";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import UtilToastMessages from "../../Utility/UtilToastMessages/UtilToastMessages";
 import { ResetPasswordApi } from "../../Utility/UtilApi/UtilApi";

const ResetPasswordModal = ({
  isOpen,
  onClose,
  setToastmessage,
  setToastColor,
  handleSnackbarClick,
}) => {
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  let { token } = useParams();
  const navigate = useNavigate();
  const [lowercaseValid, setLowercaseValid] = useState(false);
  const [uppercaseValid, setUppercaseValid] = useState(false);
  const [digitValid, setDigitValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [lengthValid, setLengthValid] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
  }, [pwd]);

  const handleSubmit = () => {
    if (!pwd || !confirmPwd || !validPwd) {
      setToastmessage("Please enter the valid password");
      setToastColor(false);
      handleSnackbarClick();
      return;
    } else {
      if (pwd === confirmPwd) {
        let data = { newpassword: pwd };
        ResetPasswordApi(data, token)
          .then((response) => {
            if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
              setToastColor(response?.data?.success);
              setToastmessage(response?.data?.message);
              handleSnackbarClick();
              setConfirmPwd("");
              setPwd("");
              setTimeout(() => {
                navigate(`/home`);
              }, 2000);
            }
          })
          .catch((err) => {
            console.log("@@@", err.response.message);
            setToastColor(err.response.data.success);
            setToastmessage(err.response.data.message);
            handleSnackbarClick();
          });
      } else if (pwd !== confirmPwd) {
        setToastmessage("New password and confirm password is invalid");
        setToastColor(false);
        handleSnackbarClick();
      }
    }
  };

  const handleChangePassword = (newPassword) => {
    setPwd(newPassword);
    setLowercaseValid(/[a-z]/.test(newPassword));
    setUppercaseValid(/[A-Z]/.test(newPassword));
    setDigitValid(/[0-9]/.test(newPassword));
    setSpecialCharValid(/[!@#$%]/.test(newPassword));
    setLengthValid(newPassword.length >= 8 && newPassword.length <= 24);
  };

  return (
    <Modal open={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          height: "auto",
          bgcolor: PageBackgroundColor,
          borderRadius: "5px",
          p: 2,
          outline: "none",
          zIndex: 10, // Ensure the modal stays above the iframe
        }}
      >
        <Typography
          style={{
            fontFamily: fontFamilyall,
            textAlign: "center",
            fontSize: "20px",
            marginTop: "20px",
          }}
        >
          Reset Password ?
        </Typography>
       
        <div style={{ marginTop: "20px" }}>
          <FormControl sx={{ width: "100%" }}>
            <FormLabel
              for="email"
              style={{
                fontWeight: "bold",
                color: TextColor,
                fontFamily: fontFamilyall,
              }}
            >
              New Password
            </FormLabel>
            <OutlinedInput
              sx={{
                height: "4ch",
                "& input": {
                  padding: "2px 0px 0px 10px",
                },
              }}
              name="pwd"
              id="pwd"
              type="password"
              value={pwd}
              fullWidth
              autoComplete="new-pwd"
              placeholder="New Password"
              onFocus={() => setPwdFocus(true)}
              onChange={(e) => handleChangePassword(e.target.value)}
            />
          </FormControl>
        </div>
        <div style={{ marginTop: "20px" }}>
          <FormControl sx={{ width: "100%" }}>
            <FormLabel
              for="email"
              style={{
                fontWeight: "bold",
                color: TextColor,
                fontFamily: fontFamilyall,
              }}
            >
              Confirm Password
            </FormLabel>
            <OutlinedInput
              sx={{
                height: "4ch",
                "& input": {
                  padding: "2px 0px 0px 10px",
                },
              }}
              name="confirmPwd"
              id="confirmPwd"
              type="password"
              value={confirmPwd}
              fullWidth
              autoComplete="new-confirmPwd"
              placeholder="Confirm Password"
              onChange={(e) => setConfirmPwd(e.target.value)}
            />
          </FormControl>
        </div>
        <br />

        {pwdFocus && (
 <p
 id="pwdnote"
 className={
   pwdFocus && pwd && !validPwd ? "instructions" : "offscreen"
 }
>
 <FontAwesomeIcon
   icon={lowercaseValid ? faCheckCircle : faInfoCircle}
   style={{ color: lowercaseValid ? "green" : "red" }}
 />
 <span style={{ color: lowercaseValid ? "green" : "red" }}>
   {" "}
   Requires at least one lowercase letter.
 </span>
 <br />
 <FontAwesomeIcon
   icon={uppercaseValid ? faCheckCircle : faInfoCircle}
   style={{ color: uppercaseValid ? "green" : "red" }}
 />
 <span style={{ color: uppercaseValid ? "green" : "red" }}>
   Requires at least one uppercase letter.
 </span>
 <br />
 <FontAwesomeIcon
   icon={digitValid ? faCheckCircle : faInfoCircle}
   style={{ color: digitValid ? "green" : "red" }}
 />
 <span style={{ color: digitValid ? "green" : "red" }}>
   Requires at least one digit.
 </span>
 <br />
 <FontAwesomeIcon
   icon={specialCharValid ? faCheckCircle : faInfoCircle}
   style={{ color: specialCharValid ? "green" : "red" }}
 />
 <span style={{ color: specialCharValid ? "green" : "red" }}>
   {" "}
   Requires at least one special character (one of !@#$%).
 </span>
 <br />
 <FontAwesomeIcon
   icon={lengthValid ? faCheckCircle : faInfoCircle}
   style={{ color: lengthValid ? "green" : "red" }}
 />
 <span style={{ color: lengthValid ? "green" : "red" }}>
   {" "}
   Requires a total length between 8 and 24 characters.
 </span>
 <br />
</p>
        )}
       
        <div style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            style={{
              fontFamily: fontFamilyall,
              color: TextColor,
              background: ButtonsColor,
            }}
            fullWidth
            onClick={handleSubmit}
          >
            Reset Password
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default function ResetPassword() {
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toastColor, setToastColor] = useState();
  const { token } = useParams(); // Get the token from the URL

  const handleSnackbarClick = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  // Construct the iframe URL using the token
  const iframeSrc = `/home`;

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <iframe
        src={'/home'}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1, // Place iframe below the modal
        }}
        title="Reset Password Background"
      />
      <div
        style={{
          position: "relative",
          zIndex: 2, // Ensure content stays above the iframe
          height: "100vh",
          width: "100%",
        }}
      >
        <ResetPasswordModal
          setToastmessage={setToastmessage}
          setToastColor={setToastColor}
          handleSnackbarClick={handleSnackbarClick}
        />
        <UtilToastMessages
          isOpen={isSnackbarOpen}
          handleClose={handleSnackbarClose}
          data={toastmessage}
          severity={toastColor}
        />
      </div>
    </div>
  );
}